<script setup lang="ts">
import fpsImg from "@/assets/fps-qrcode.jpg";
import paymeImg from "@/assets/payme-qrcode.jpg";
import _service from "@/service";
import { isStarNest, webviewClose } from "@/utils/starnest";
import countryJson from '@/assets/country.json'
import { computed, reactive, ref } from "vue";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { closeToast, Popup, showLoadingToast } from "vant";
import { isInIframe, symbolByCurrency } from "@/utils";
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const productParams = ref<any>();
const selectedCountry = ref<any>({});
const searchWord = ref<string>('');
const isShowCountryModal = ref<boolean>(false);
const parentUrl = sessionStorage.getItem('PARENT_URL')
const returnUrl = isInIframe() ? `${parentUrl}?status=success`: `${window.location.origin}/pay-success`

let form = reactive({
  phone:'',
  firstName:'',
  lastName:'',
  pan:'',
  expirationYear:'',
  expirationMonth:'',
  securityCode:'',
  issuingBank:'',
  street1:'',
  street2:'',
  city:'',
  postcode:'',
  country:'',
})

const state = reactive({
  popupRight: "0px",
});

onMounted(() => {
  const params: any = route.query.params || "";
  productParams.value = params ? JSON.parse(params) : null;
  console.log(productParams.value,'productParams-==');

});
const submitFn = async () => {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    console.log(form,'form--');
  form = {
    phone:'0',
    firstName:'1',
    lastName:'2',
    pan:'3',
    expirationYear:'4',
    expirationMonth:'5',
    securityCode:'6',
    issuingBank:'7',
    street1:'8',
    street2:'9',
    city:'10',
    postcode:'11',
    country:'12',
  }
  const postData = {
    id:productParams.value.id,
    channelCode:productParams.value.payChannel,
    channelExtras:form,
    displayMode:'url',
    returnUrl:''
  }
  const res:any = await _service.submitOrder(postData)
    // if (!res.data) {
    //   window.location.replace(`${window.location.origin}/pay-fail`)
    //   return false
    // }
    if (res.data.displayMode === 'url') {
      window.location.href = res.data.displayContent
    }
    closeToast()
  } catch (error) {
    
  }
  
  // webviewClose();
};

// 打开弹窗
const openPopup = (account: any) => {
  isShowCountryModal.value = true;
  let rightPx =
    (window.innerWidth - document!.querySelector(".media-375").clientWidth) / 2;
  state.popupRight = rightPx + "px";
};

// 关闭弹窗
const closePopup = () => {
  isShowCountryModal.value = false;
};

// 选择国家
const handleSelect = (data:any) => {
  selectedCountry.value = data
  form.country = data.country_code
  isShowCountryModal.value = false
}

// 字符串筛选国家地区
const countryList = computed((item: any) => {
  if (searchWord.value) {
    const _arr = countryJson.filter((item: any) => {
      if (`${item.name_en}${item.name_cn}${item.country_code}`.includes(searchWord.value)) {
        return item
      }
    })
    return _arr
  } else {
    return countryJson
  }

})

const validateInput = (event:any,item:string,length:number) => {
  const value = event.target.value;
  if (value.length > length) {
    console.log(88);
    // 只允许两位数字，超过两位则截取前两位
    form[item] = value.slice(0, length);
  }
}
</script>

<template>
  <div class="payment-layout">
    <div class="media-375">
      <div class="section">
        <div class="order-info flex-col-center-center">
          <div class="row flex-row-between-center">
            <span class="left">Billing descriptor</span>
            <span class="right">{{productParams?.productName}}</span>
          </div>
          <div class="row flex-row-between-center">
            <span class="left">Order Number</span>
            <span class="right">{{ productParams?.no }}</span>
          </div>
          <div class="row flex-row-between-center">
            <span class="left">Order Amout</span>
            <span class="right price"
              ><span class="symbol">{{ symbolByCurrency[productParams?.coin] }}</span>{{productParams?.price.toFixed(2)}}</span
            >
          </div>
        </div>
      </div>
      <div class="section gap flex-col-center-center">
        <div class="inputer">
          <input type="number" placeholder="Phone" v-model="form.phone" />
        </div>
        <div class="split flex-row-between-center">
          <div class="inputer">
            <input
              type="text"
              placeholder="first name"
              v-model="form.firstName"
            />
          </div>
          <div class="inputer">
            <input
              type="text"
              placeholder="last name"
              v-model="form.lastName"
            />
          </div>
        </div>
        <div class="inputer">
          <input
            type="text"
            placeholder="Issuing Bank"
            v-model="form.issuingBank"
          />
        </div>
        <div class="inputer">
          <input type="number" placeholder="card number" v-model="form.pan" />
        </div>
        <div class="inputer">
          <input
            type="number"
            placeholder="expiration date(MM)"
            @input="validateInput($event, 'expirationMonth', 2)"
            v-model="form.expirationMonth"
          />
          /
          <input
            type="number"
            @input="validateInput($event, 'expirationYear', 4)"
            placeholder="expiration date(YYYY)"
            v-model="form.expirationYear"
          />
        </div>
        <div class="inputer">
          <input
            type="text"
            placeholder="security code"
            v-model="form.securityCode"
          />
        </div>
      </div>
      <div class="section gap">
        <div class="header flex-row-between-center">
          <span>billing address</span>
          <span class="text"><i class="edit-icon"></i> edit</span>
        </div>
        <div class="inputer">
          <input type="text" placeholder="address1" v-model="form.street1" />
        </div>
        <div class="inputer">
          <input type="text" placeholder="address2" v-model="form.street2" />
        </div>
        <div class="inputer">
          <input type="text" placeholder="city" v-model="form.city" />
        </div>
        <div class="inputer">
          <input
            type="text"
            placeholder="postcode / zip code"
            v-model="form.postcode"
          />
        </div>
        <div class="inputer" @click.prevent="isShowCountryModal = true">
          <div style="width: 100%" v-if="selectedCountry.name_cn">
            {{ selectedCountry.name_cn || "Country" }}
          </div>
          <div style="width: 100%; color: #666; font-size: 16px" v-else>
            Country
          </div>
          <i class="down-icon"></i>
        </div>
      </div>
    </div>
    <div class="pay-btn" @click="submitFn">Pay {{symbolByCurrency[productParams?.coin]}} {{productParams?.price.toFixed(2)}}</div>
    <Popup
      v-model:show="isShowCountryModal"
      overlay-class="popup_receive_overlay"
      :style="{ left: state.popupRight }"
      class="popup_receive_com"
      position="bottom"
    >
      <div class="popup-content">
        <div class="header">
          <div class="inputer">
            <i class="search-icon"></i>
            <input type="text" placeholder="Search" v-model="searchWord" />
          </div>
        </div>
        <div class="country-list">
          <div
            class="country-list-item"
            v-for="item in countryList"
            :key="item.country_id"
            @click="handleSelect(item)"
          >
            {{ item.name_cn }}
          </div>
          <div class="flex-row-center-center" v-if="!countryList.length">
            暂无数据
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<style lang="scss" scoped>
.payment-layout {
  height: 100%;
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
  padding-bottom: 137px;
  .section {
    background: #1a1a1a;
    padding: 16px 14px;
    margin-bottom: 4px;
    &.gap {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
  .order-info {
    background: #2a2a2a;
    padding: 16px 12px;
    gap: 16px;
    border-radius: 12px;
    .row {
      .left {
        color: #aaa;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 157.143% */
        text-transform: capitalize;
      }
      .right {
        color: #fff;
        text-align: right;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 157.143% */
        text-transform: uppercase;
        &.price {
          color: #fff;
          text-align: right;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px; /* 137.5% */
          text-transform: uppercase;
        }
        .symbol {
          color: #aaa;
          text-align: right;
          font-family: Inter;
          font-size: 10px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 160% */
          text-transform: uppercase;
          margin-right: 2px;
        }
      }
    }
  }
  .split {
    gap: 12px;
  }
  .inputer {
    border-radius: 12px;
    border: 1px solid #2a2a2a;
    padding: 12px;
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    input {
      color: #fff;
      &::placeholder {
        color: #666;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
        text-transform: capitalize;
      }
    }
    .down-icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url(../../assets/down.svg);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .header {
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    text-transform: capitalize;
    .edit-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url(../../assets/edit-white.svg);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .text {
      font-size: 14px;
    }
  }
  .pay-btn {
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 1000px;
    background: #00ffb2;
    width: 343px;
    height: 48px;
    display: flex;
    padding: 12px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    color: #0a0a0a;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
}

.popup_receive_overlay {
  background: rgba($color: #000000, $alpha: 0.8);
}

.popup_receive_com {
  background: transparent;
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  z-index: 20;
  .popup-content {
    background: #2a2a2a;
    .header {
      padding: 16px;
      width: 100%;
      .inputer {
        border-radius: 12px;
        border: 1px solid #2a2a2a;
        background: #333;
        padding: 12px;
        .search-icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../assets/search.svg);
          background-size: contain;
          background-repeat: no-repeat;
          margin-right: 8px;
        }
        input {
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px; /* 150% */
          color: #fff;
          &::placeholder {
            color: #666;
          }
        }
      }
    }
    .country-list {
      height: 500px;
      overflow-y: scroll;
      background: #2a2a2a;
      &-item {
        width: 100%;
        height: 48px;
        color: #fff;
        font-family: "Source Han Sans CN";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        display: flex;
        align-items: center;
        padding-left: 16px;
        &:active {
          background: #333;
        }
      }
    }
  }
}
</style>
